import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { AutoComplete } from "antd";
import { useSelector } from "react-redux";
import { searchAccounts, getReasonsClassified } from "../../../store/actions/precog";
import { useDispatch } from "react-redux";

const AutocompleteSelector = (props) => {
  const {
    className = "",
    initialValue = "",
    popoverPlacement = "bottom",
    value="",
    onChange,
    onSearch,
    rowId,
    placeholder = "",
    isAccountingAccounts,
    isAccountingReason,
    registrationData,
    disabled=false,
    includeSystem=false,
    onlyConfirmed=false
  } = props;

  const dispatch = useDispatch();

  const searchedAccounts = useSelector(state => state.precog.searchAccounts.data);
  const searchedReasons = useSelector(state => state.precog.reasonsClassified.data);

  const [accountsList, setaccountsList] = useState([]);
  const refReasonAutocomplete = useRef();

  useEffect(() => {
    if (!isAccountingAccounts) return;
    if (!searchAccounts?.status?.started && (!searchedAccounts?.accounts || searchedAccounts?.accounts?.lenght === 0)) {
      
      dispatch(searchAccounts(""));
    }
  }, [isAccountingAccounts]);

  useEffect(() => {
    if (!searchAccounts?.status?.started && (!searchedAccounts?.accounts || searchedAccounts?.accounts?.lenght === 0)) {
      dispatch(searchAccounts(""));
    }
  }, []);

  useEffect(() => {
    if (!isAccountingReason) return;
    dispatch(getReasonsClassified(
      "BANK_TRANSACTION",
      null,
      registrationData?.doc?.active ? "ACTIVE" : "PASSIVE"
    ));
  }, [isAccountingReason]);

  useEffect(() => {
    const optionsList = [];
    if (isAccountingAccounts) {
      if (!searchedAccounts?.accounts) return;
      searchedAccounts.accounts.map((el, index) => {
        return optionsList.push({value: `${el.code} - ${el.description?.charAt(0)?.toUpperCase()}${el?.description?.slice(1).toLocaleLowerCase()}`});
      });
    } else {
      if (!searchedReasons) return;
      searchedReasons.map((el, index) => {
        return optionsList.push({value: `${el.description} - (${el.code?.charAt(0)?.toUpperCase()}${el?.description?.slice(1).toLocaleLowerCase()})`});
      });
    }
    setaccountsList(optionsList);
  }, [isAccountingAccounts, searchedAccounts?.accounts, searchedReasons]);
  
  return (
    <div className={className} style={{ width: isAccountingAccounts ? "100%" : "inherit" }}>
      <AutoComplete    
        disabled={disabled}
        singlePopover={props.singlePopover}
        backfill={props.backfill}          
        overlayClassName={props.overlayClassName}    
        dropdownClassName={props.dropdownClassName}                                   
        ref={refReasonAutocomplete}
        allowClear={true}
        popoverPlacement={popoverPlacement}
        getPopupContainer={trigger => trigger.parentNode}
        options={accountsList}
        style={{...props.style, width: "100%"}}
        initialValue={initialValue}
        value={value}
        filterOption={(inputValue, option) => {
          if (inputValue === initialValue) return true;
          return option.value.toUpperCase().indexOf(inputValue.toUpperCase())>-1;
        }
        }
        placeholder={placeholder}
        notFoundContent={"Nessun risultato"}
        onClear={e => {
          onChange({rowId: rowId, code: "", title: ""});
          refReasonAutocomplete.current.focus();
        }}
        onSearch={(val)  => {
          onSearch(val, rowId);
          /** Risolve il problema del set veloce di stringhe di testo che perdono i caratteri */
          // const currentVal = el.split("-");
          /* onChange({
            rowId: rowId,
            code: "",
            title: el
          });*/
          if (val.length > 1)
            dispatch(searchAccounts(
              val, 10, includeSystem, onlyConfirmed
            ));
        }}
        onSelect={ (el) => {          
          const currentVal = el.split("-");          
          onChange({
            rowId: rowId,
            code: currentVal[0],
            title: currentVal[1],
            onSelect: true
          });
          refReasonAutocomplete.current.blur();
        }}
        
      />
    </div>
  );
};

export default AutocompleteSelector;
